import { useEffect, useState } from "react";
import {
  requestOptions,
  VIPSDataServiceURL,
  OCC_ORDER_SUBMIT_URL,
} from "../../Constants/GlobalConstant";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useSelector } from "react-redux";
import { createSearchParams, useLocation } from "react-router-dom";
import { pink } from "@mui/material/colors";
import LaunchIcon from "@mui/icons-material/Launch";
import { getMessage } from "../../CommonFuntion/messages";
import { formatDate } from "../../CommonFuntion/ConfirmOrderHelper";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#003366",
    color: theme.palette.common.white,
    padding: 1,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
  },
}));

let divisionId = "";
let store_grp = "";
let DivDesc = "";
let user_source = "";
let store_grp_desc = "";
const ConfirmOrder = () => {
  let location = useLocation();
  var SessionArray = useSelector((state) => state.SessionArray);
  const searchParams = createSearchParams(location.search);

  useEffect(() => {
    if (typeof SessionArray !== "undefined") {
      SessionArray = JSON.parse(localStorage.getItem("sessionArray"));
    }
    if (typeof SessionArray === "object") {
      if (
        SessionArray &&
        typeof SessionArray === "object" &&
        Object.entries(SessionArray).length > 1
      ) {
        SessionArray.forEach(function (item) {
          if (item.Key == "division_id") {
            divisionId = item.Value;
          }
          if (item.Key == "store_grp") {
            store_grp = item.Value;
          }
          if (item.Key == "DivDesc") {
            DivDesc = item.Value;
          }

          if (item.Key == "user_source") {
            user_source = item.Value;
          }
          if (item.Key == "store_grp_desc") {
            store_grp_desc = item.Value;
          }
        });
      }
    }
  });


  let storGroupURL =
    process.env.REACT_APP_SITE_URL +
    `/Pages/orders/Stores.aspx?store_grp=${searchParams.get("store_grp")}&` +
    `session_id=` +
    searchParams.get("session_id");
  let occAfterOrderSubmitURL = `${OCC_ORDER_SUBMIT_URL}`;
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const orderIDs = searchParams.get("OrderID")?.split("|") || [];
    // Prefer SelectedDivision from URL (set by factory config flow), fall back to session divisionId
    const effectiveDivisionId = searchParams.get("SelectedDivision") || divisionId;
    orderIDs.forEach((orderID, index) => {
      let URL =
        `${VIPSDataServiceURL}` +
        `/Order/GetOrderInformation?divisionID=${effectiveDivisionId}&` +
        `orderIDList=${orderID}`;
      setIsLoading(true);
      fetch(URL, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          // Append each order data to the existing state data
          setData((prevData) => ({
            ...prevData,
            [`Order${index}`]: data, // Assuming each order data is stored in a separate key
          }));
          setIsLoading(false);
        })
        .catch((error) => console.error(error));
    });
  }, []);

  return (
    <>
      <div>
        {isLoading && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
            <p>Processing Order, please wait...</p>
          </div>
        )}

        <h1 className="tableformik">
          <b>{getMessage("orderConfirmedMessage")}</b>
        </h1>
        <br />

        <div className="tableformik">
          <table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Division/Location</StyledTableCell>
                <StyledTableCell>Avery Order Reference</StyledTableCell>
                <StyledTableCell>Order Date</StyledTableCell>
                <StyledTableCell>Request Date</StyledTableCell>
                <StyledTableCell>PO Reference</StyledTableCell>
                <StyledTableCell>Billing Account</StyledTableCell>
                <StyledTableCell>Billing Address</StyledTableCell>
                <StyledTableCell>Shipping Address</StyledTableCell>
                <StyledTableCell>Customer Services Contact</StyledTableCell>
              </TableRow>
            </TableHead>
            <tbody>
              {Object.keys(data).length === 0 ? (
                <tr>
                  <td colSpan={9}>No order data available.</td>
                </tr>
              ) : (
                Object.keys(data).map((orderKey, index) => (
                  <tr key={index}>
                    {/* Render data for each order */}
                    <td>
                      {data[orderKey]?.Order &&
                        data[orderKey].Order.length > 0 && (
                          <>
                            {data[orderKey].Order[0].division_id}-{DivDesc}
                          </>
                        )}
                    </td>
                    <td>
                      {data[orderKey]?.Order &&
                        data[orderKey].Order.length > 0 &&
                        data[orderKey].Order[0].order_id}
                    </td>
                    <td>
                      {data[orderKey]?.Order &&
                        data[orderKey].Order.length > 0 &&
                        formatDate(data[orderKey].Order[0].customer_order_date)}
                    </td>
                    <td>
                      {data[orderKey]?.Order &&
                        data[orderKey].Order.length > 0 &&
                        formatDate(data[orderKey].Order[0].requestDate)}
                    </td>

                    <td>
                      {data[orderKey]?.Order &&
                        data[orderKey].Order.length > 0 &&
                        data[orderKey].Order[0].customer_PO}
                    </td>
                    <td>
                      {data[orderKey]?.Order &&
                        data[orderKey].Order.length > 0 &&
                        data[orderKey].Order[0].customer_id}
                    </td>
                    <td>
                      {data[orderKey]?.InvoiceAddress?.customer_name}
                      <br></br>
                      {data[orderKey]?.InvoiceAddress?.customer_address1}
                      <br></br>
                      {data[orderKey]?.InvoiceAddress?.customer_address2}
                      <br></br>
                      {data[orderKey]?.InvoiceAddress?.customer_address3}
                      <br></br>
                      {data[orderKey]?.InvoiceAddress?.customer_address4}
                    </td>
                    <td>
                      {data[orderKey]?.DeliveryAddress?.contact_name}
                      <br></br>
                      {data[orderKey]?.DeliveryAddress?.delivery_address1}
                      <br></br>
                      {data[orderKey]?.DeliveryAddress?.delivery_address2}
                      <br></br>
                      {data[orderKey]?.DeliveryAddress?.delivery_address3}
                      <br></br>
                      {data[orderKey]?.DeliveryAddress?.delivery_address4}
                    </td>
                    <td>vipssupportMailBox@eu.averydennison.com</td>
                    {/* Render other table data fields as needed */}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <br />
        <div className="tableformik">
          <LaunchIcon sx={{ color: pink[500] }} />
          {searchParams.get("OCC") ? (
            <a
              href={occAfterOrderSubmitURL}
              rel="noopener noreferrer"
              style={{ color: "black" }}
            >
              {getMessage("btnBackToMarketplace")}
            </a>
          ) : (
            <a
              href={storGroupURL}
              rel="noopener noreferrer"
              style={{ color: "black" }}
            >
              {getMessage("orderMore")} {store_grp_desc}
            </a>
          )}
        </div>
      </div>
    </>
  );
};

export default ConfirmOrder;
